import { apApi } from 'services/api/instances';

export type {
  EndpointMethod,
  EndpointScope,
  EndpointCommon,
  EndpointBase,
  EndpointArgs,
  EndpointArgsTuple,
  EndpointBody,
  EndpointPath,
  EndpointQuery,
  EndpointResponse,
} from 'services/api/endpointTypes';

// Backward-compatible default endpoint — bound to the AP API client.
export const endpoint = apApi.endpoint;
